function _intersect(set1, set2) {
    let z = Array.from(set1).filter(x => set2.has(x));
    return new Set(z);
}

export function filterTags(tags) {
    let tagsToRemove = [];
    for (let i in tags) {
        let tag = tags[i];
        for (let j in tags) {
            let otherTag = tags[j];
            if (otherTag === tag) {
                continue;
            }
            let tagSplit = new Set(tag.split(' '));
            let otherTagSplit = new Set(otherTag.split(' '));
            let intersect = _intersect(tagSplit, otherTagSplit);
            if (intersect.size > 1) {
                tagsToRemove.push(tag);
                break;
            }
        }
    }

    tags = new Set(tags);
    for (let i in tagsToRemove) {
        tags.delete(tagsToRemove[i]);
    }

    return Array.from(tags);
}

